module.exports = __webpack_public_path__ + "static/media/overpass-mono-bold.433b5c73.eot";